import { render, staticRenderFns } from "./advertiser-navbar.vue?vue&type=template&id=2c162c38"
import script from "./advertiser-navbar.vue?vue&type=script&lang=js"
export * from "./advertiser-navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports